import React from 'react';
import './Lora.css';
import FMSimage from '../Assets/Picture1lora.jpg'; // First image (full size)
import FMSimage2 from '../Assets/lora1 (2).jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/lora2.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/lora3.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/lora4.jpg'; // Image for Industries section

const Lora = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">LoRa Based Water Meter</h1>
                    <p className="FMS-description">
                        A LoRa Based Water Meter is designed to manage and track water usage, storage, and consumption efficiently, providing real-time data, reducing wastage, and improving water management processes. This system typically involves hardware sensors, software platforms, and wireless communication technologies that integrate to track water levels, monitor consumption, and generate reports for analysis.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="LoRa Based Water Meter" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our LoRa Based Water Meter provides real-time monitoring of water levels and consumption, with automated alerts for issues like leakage or overflow. Access the system remotely from any device and receive detailed reports to optimize water efficiency. It also ensures data security and regulatory compliance.
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Advanced Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        The system utilizes advanced sensors to continuously monitor water levels in storage tanks or pipelines. Data is transmitted wirelessly to a centralized platform, where it is processed and displayed in an intuitive dashboard. Alerts for unusual activity, such as water leakage or excessive consumption, ensure proactive management. Reports and analytics provide actionable insights to help businesses save costs and improve efficiency.
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our LoRa Based Water Meter</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our LoRa Based Water Meter stands out due to its precision, reliability, and user-friendly design. It minimizes operational costs, prevents unauthorized water access, and enhances overall efficiency with its robust analytics and real-time updates. By choosing our solution, you benefit from:
                        <ul>
                            <li>Accurate and reliable water tracking</li>
                            <li>Seamless integration with existing systems</li>
                            <li>Customizable alerts and reporting</li>
                            <li>Enhanced security and leakage prevention</li>
                            <li>Easy installation and minimal maintenance</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our System */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our LoRa Based Water Meter</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using LoRa Water Meter" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our LoRa Based Water Meter is trusted by a variety of industries to optimize water management and enhance operational efficiency. These industries rely on our solution for its accuracy, reliability, and cost-saving benefits:
                        <ul>
                            <li>Municipal Water Management</li>
                            <li>Agriculture & Irrigation</li>
                            <li>Smart Cities</li>
                            <li>Industrial Water Usage</li>
                            <li>Residential & Commercial Buildings</li>
                            <li>Hotels & Resorts</li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Lora;